module.exports = __webpack_public_path__ + "media/images/scoreBet__scoreUp-daf99fb578f0432b272779cdbd32de2e.png";